export default __webpack_public_path__ + "static/headline-63bfe72f4ebcc52ff5169b2837552db5.svg";